import { isCheckoutDisabled } from '~~/helpers/Checkout/isCheckoutDisabled';
import { SHOW_CONFIRMATION } from '~~/constants/queryOptions';
import {
  SALESFORCE_ACCEPTED_CHARACTER_SET,
  SALESFORCE_FORM_INDICATOR,
  SALESFORCE_WEBFORM_REASONS,
} from '~~/constants/salesforce';
import type { CountryCodeValue } from '~~/types/localization/localizationHelperTypes';
import type { SalesforceWebformReason } from '~~/types/salesforce';

const OFFSET_FOR_EXCLUDING_NONE_OPTION = 1;
const OFFSET_FOR_EXCLUDING_OTHER_OPTION = -1;

export const generateWebformEndpoint = ({
  domain,
  orgId,
}: {
  domain: string;
  orgId: string;
}) => {

  if (!domain || !orgId) {

    throw new Error('Both domain and orgId are required.');
  
  }

  const url = new URL(domain);
  const params = new URLSearchParams({
    encoding: SALESFORCE_ACCEPTED_CHARACTER_SET,
    orgId,
  });

  url.search = params.toString();

  return url.toString();

};

export const getCurrentUrlWithRedirectionFlag = (): string => {

  if (typeof window !== 'object') {

    return '';
  
  }

  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.append(SHOW_CONFIRMATION, 'true');

  return currentUrl.toString();

};

export const getSalesforceWebformReasons = (countryCode: CountryCodeValue): SalesforceWebformReason[] => {

  if (isCheckoutDisabled(countryCode)) {

    return SALESFORCE_WEBFORM_REASONS.filter((reason) => {

      return reason.indicator !== SALESFORCE_FORM_INDICATOR.SALESFORCE_REASON_SALES;
    
    });
  
  }

  return SALESFORCE_WEBFORM_REASONS;

};

export const getSalesforceWebformSpecificReasons = (countryCode: CountryCodeValue): SalesforceWebformReason[] => {

  return getSalesforceWebformReasons(countryCode)
    .slice(OFFSET_FOR_EXCLUDING_NONE_OPTION, OFFSET_FOR_EXCLUDING_OTHER_OPTION);

};

export const getSalesforceWebformVisualOptions = (countryCode: CountryCodeValue): SalesforceWebformReason[] => {

  return getSalesforceWebformReasons(countryCode).slice(OFFSET_FOR_EXCLUDING_NONE_OPTION);

};
